<h1 ce-dialog-header>This service uses cookies</h1>
<div ce-dialog-content class="u-spacing-lg-pa">
    <p class="u-spacing-md-mb">We use cookies and store data such as IP addresses for two purposes.</p>
    <h2 class="u-text-title-sm u-spacing-xs-mb">Essential cookies</h2>
    <p class="u-spacing-md-mb">
        Essential cookies are necessary for this web service to work properly. These cookies are always active.
    </p>
    <h2 class="u-text-title-sm u-spacing-xs-mb">Analytics cookies</h2>
    <p class="u-spacing-sm-mb">
        Analytics cookies are used to collect usage analytics data. We use this data to understand how the service is
        used and to improve your experience with it.
    </p>
    <p class="u-spacing-sm-mb">
        You can <strong>accept all cookies</strong> or <strong>accept essential cookies only</strong> and later change
        your choice in the profile section of your ChargEye account.
    </p>
</div>
<div ce-dialog-actions>
    <button (click)="giveConsent(false)" ce-button ce-button-type-secondary>Accept essential only</button>
    <button (click)="giveConsent(true)" ce-button>Accept all</button>
</div>
